import React, { useState } from 'react';
import get from 'get-value';
import { Option } from 'shared/interface/globalInterface';

import InputWrapper from 'modules/af_cm_ui_kit/components/InputWrapper/InputWrapper';
import { Props } from './types';
import { Select } from 'modules/af_cm_ui_kit/components';
import { Button } from 'lmc-ui-library';

import styles from './styles.module.scss';
import { useFormikContext } from 'formik';

const ChangeableSelect: React.FC<Props> = ({
  title,
  subtitle,
  placeholder,
  field,
  form,
  disabled,
  required,
  options,
  handleClick,
  searchable,
  extraContent = [],
  noOptionsText,
  onChangeClick,
  previousValue,
  updatePreviousValue,
  afterSaveButton,
  isRequired = false,
}) => {
  field.value = field.value || '';

  const [initialValue, setInitialValue] = useState<string>(field.value);

  const { dirty } = useFormikContext();
  const prevValue = updatePreviousValue ? previousValue : initialValue;

  const shouldBeDisabled = !field.value || field.value === prevValue || get(form.errors, field.name) || !dirty;

  const { setFieldValue, setFieldTouched } = form;

  const handleSelection = (option: Option) => {
    setFieldValue(field.name, option.value);

    if (handleClick) {
      handleClick(option);
    }
  };

  const handleBlur = () => setFieldTouched(field.name);

  const handleChangeClick = () => {
    if (shouldBeDisabled) return;

    if (updatePreviousValue) {
      updatePreviousValue(field.value);
    } else {
      setInitialValue(field.value);
    }

    return onChangeClick(field.value, previousValue);
  };

  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}
      isRequired={isRequired}>
      <div className={styles.inputContainer}>
        <Select
          value={field.value}
          options={options}
          required={required}
          name={field.name}
          onBlur={handleBlur}
          searchable={searchable}
          handleClick={handleSelection}
          title={title}
          placeholder={placeholder}
          disabled={disabled}
          noOptionsText={noOptionsText}
        />

        <Button
          mode="secondary"
          borderVariant="rectangle"
          type="button"
          onClick={handleChangeClick}
          style={{ width: 106 }}
          disabled={shouldBeDisabled || disabled}>
          Save
        </Button>
        {afterSaveButton && afterSaveButton()}
      </div>
    </InputWrapper>
  );
};

export default ChangeableSelect;
